import { Component, Input } from '@angular/core';
import { Product } from '../../interface/product.interface';
import { Voucher } from '../../interface/voucher.interface';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-product-suggestion',
  templateUrl: './product-suggestion.component.html',
  styleUrl: './product-suggestion.component.scss'
})
export class ProductSuggestionComponent {

  @Input() productSuggestion: Product;
  @Input() vouchers: Voucher[] = [];
  @Input() isAuthenticated: boolean = false;

  Math = Math;

  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit() {
    if (this.productSuggestion) {
      this.productSuggestion.progressLabel = this.commonService.getProgressLabel(this.productSuggestion);
    }
  }

  tagCount(): number {
    let count = 0;
    if (this.hasTag('san-pham-doc-quyen')) count++;
    if (this.isPromotionalProduct(this.productSuggestion)) count++;
    return count;
  }

  hasTag(tagSlug?: string): boolean {
    return this.productSuggestion?.labels?.some((l: any) => l.slug === tagSlug);
  }

  isPromotionalProduct(item: any): boolean {
    if (!item || !this.vouchers?.length) return false;
    const productLabelSlugs = item.labels?.map((l: any) => l.slug) ?? [];
    const productSku = String(item?.sku ?? '');
    const categoryIds = item.categories?.map((c: any) => c.categoryId) ?? [];

    for (const voucher of this.vouchers) {
      const condition = voucher.voucherCondition;
      if (!condition) continue;

      const labelQtyConditions = condition.applicableLabelQuantity ?? [];
      for (const cond of labelQtyConditions) {
        if (!cond?.labels?.length) continue;
        const condLabels = Array.isArray(cond.labels)
          ? cond.labels
          : [cond.labels];
        if (
          condLabels.some((slug: string) => productLabelSlugs.includes(slug))
        ) {
          return true;
        }
      }

      const applicableLabels = condition.applicableLabels ?? [];
      if (
        applicableLabels.some((slug: string) =>
          productLabelSlugs.includes(slug),
        )
      ) {
        return true;
      }

      const productQtyConditions = condition.productQuantityConditions ?? [];
      if (
        productQtyConditions.some(
          (cond: any) => String(cond?.sku ?? '') === productSku,
        )
      ) {
        return true;
      }

      const applicableCategoryIds = condition.applicableCategoryIds ?? [];
      if (
        applicableCategoryIds.some((cid: string) => categoryIds.includes(cid))
      ) {
        return true;
      }
      const categoryQtyConditions = condition.applicableCategoryQuantity ?? [];
      if (
        categoryQtyConditions.some((cond: any) =>
          categoryIds.includes(cond.categoryId),
        )
      ) {
        return true;
      }
    }
    return false;
  }
}
